import {  GiCakeSlice, GiHealthPotion, GiBreadSlice, GiChefToque, GiSaucepan, GiBacon, GiGlassShot } from 'react-icons/gi';
import { TbSalad } from 'react-icons/tb';
import { NavLink } from 'react-router-dom';
import "../styles/Category.css";

function Category() {
  return (
    <div className="category-list">
      <NavLink
        to={'/cuisine/Main Course'}
        className="category-link"
      >
        <GiChefToque />
        <h4>Main Course</h4>
      </NavLink>
      
      <NavLink
        to={'/cuisine/Healthy'}
        className="category-link"
      >
        <GiHealthPotion />
        <h4>Healthy</h4>
      </NavLink>

      <NavLink
        to={'/cuisine/Side Dish'}
        className="category-link"
      >
        <TbSalad />
        <h4>Side Dish</h4>
      </NavLink>
      
      <NavLink
        to={'/cuisine/Sauce'}
        className="category-link"
      >
        <GiSaucepan />
        <h4>Sauce</h4>
      </NavLink>
      
      <NavLink
        to={'/cuisine/Dessert'}
        className="category-link"
      >
        <GiCakeSlice />
        <h4>Dessert</h4>
      </NavLink>

     
      <NavLink
        to={'/cuisine/Bread'}
        className="category-link"
      >
        <GiBreadSlice />
        <h4>Bread</h4>
      </NavLink>

      <NavLink
        to={'/cuisine/Breakfast'}
        className="category-link"
      >
        <GiBacon />
        <h4>Breakfast</h4>
      </NavLink>

      <NavLink
        to={'/cuisine/Drink'}
        className="category-link"
      >
        <GiGlassShot />
        <h4>Drink</h4>
      </NavLink>
    
    </div>
  );
}

export default Category;